module.exports = __webpack_public_path__ + "static/app/img/service-legend.6045c93.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/service-legend.svg
// module id = Zcx+
// module chunks = 1